import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import PageContainer from '../components/layout/PageContainer'
import useRequireAuth from '../util/auth/useRequireAuth'
import useStore from '../util/store/auth'
import EmptyState from '../components/EmptyState'
import EmptyPageContainer from '../components/EmptyPageContainer'

const Root = () => {
  useRequireAuth('/')

  const { directory } = useStore()
  const navigate = useNavigate()

  useEffect(() => {
    if (directory) {
      navigate('/dashboards/overall-stats')
    }
  }, [directory, navigate])

  if (!directory) {
    return (
      <EmptyPageContainer>
        <EmptyState
          emptyStateVariant="error"
          title="Please select an organization to continue"
          description=""
        />
      </EmptyPageContainer>
    )
  }

  return <PageContainer></PageContainer>
}

export default Root
